import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

interface SVGRProps {
  title?: string
  titleId?: string
}
const TelegramIcon = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M10 3.44539e-08C8.02219 3.44539e-08 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433284 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C20.0001 8.68675 19.7415 7.38634 19.239 6.17304C18.7365 4.95973 17.9999 3.8573 17.0713 2.92869C16.1427 2.00008 15.0403 1.26349 13.827 0.760983C12.6137 0.258474 11.3133 -0.000108979 10 3.44539e-08ZM13.1795 15.1525C13.1421 15.2458 13.0851 15.33 13.0125 15.3996C12.9398 15.4691 12.8532 15.5223 12.7583 15.5556C12.6634 15.5889 12.5625 15.6015 12.4623 15.5926C12.3622 15.5837 12.265 15.5535 12.1775 15.504L9.46284 13.3946L7.72052 15.002C7.6801 15.0319 7.6328 15.0511 7.583 15.0579C7.5332 15.0647 7.48248 15.0589 7.43552 15.0409L7.76952 12.0525L7.78021 12.061L7.78704 12.002C7.78704 12.002 12.672 7.55445 12.871 7.36496C13.0725 7.17596 13.006 7.13496 13.006 7.13496C13.0175 6.90443 12.6445 7.13496 12.6445 7.13496L6.172 11.299L3.47651 10.381C3.47651 10.381 3.06251 10.2325 3.02351 9.906C2.98251 9.582 3.49 9.406 3.49 9.406L14.207 5.14849C14.207 5.14849 15.088 4.75597 15.088 5.406L13.1795 15.1525Z"
      fill="currentColor"
    />
  </svg>
)
const ForwardRef = forwardRef(TelegramIcon)
export { ForwardRef as ReactComponent }
